import { ReactComponent as HardHatImage } from 'components/assets/hard-hat.svg';
import BasePageWithTopNav from 'components/layout/TopNavigationLayout';
import ErrorCover from 'components/widgets/Error/Cover';

const PageNotFound = () => {
  return (
    <BasePageWithTopNav>
      <ErrorCover
        errorImage={<HardHatImage />}
        title="Page not found"
        description="Sorry for the inconvenience. This page was removed or is temporarily unavailable."
      />
    </BasePageWithTopNav>
  );
};

export default PageNotFound;
